/**
 * Carousels
 *  
 * HTML authors need to do the following:
 * * Apply this class to the parent element: "js-carousel"
 * * Apply this class on each container that needs to update dynamically: "js-carousel-view"
 * * Apply this class on each item that would change in the view: "js-carousel-item"
 */

const cssClasses = {
    active: 'js-carousel-item_active',
};

export default class Carousel {
    constructor(rootElement, views, length, nextElements, previousElements) {
        this._activePage = null;
        this._length = length;
        this._rootElement = rootElement;
        this._views = views;
        this._init(nextElements, previousElements);
    }

    get activePage() {
        return this._activePage;
    }

    set activePage(value) {
        if (typeof value !== 'number') {
            return;
        }

        const previousValue = this._activePage;

        // Deactivate current page.
        if (previousValue !== null) {
            for (let i = 0; i < this._views.length; i++) {
                const element = this._views[i][previousValue];
                element.classList.remove(cssClasses.active);
            }
        }

        // Activate current page.
        for (let i = 0; i < this._views.length; i++) {
            const element = this._views[i][value];
            element.classList.add(cssClasses.active);
        }

        this._activePage = value;

        const activePageChangedEvent = document.createEvent('CustomEvent');
        activePageChangedEvent.initCustomEvent(
            'activePageChanged', false, false,
            { currentPage: value, previousPage: previousValue });
        document.dispatchEvent(activePageChangedEvent);
    }

    _init(nextElements, previousElements) {
        this.activePage = 0;

        // Wire up next controls.
        for (let i = 0; i < nextElements.length; i++) {
            const nextElement = nextElements[i];
            nextElement.addEventListener('click', this._onNext.bind(this));
        }

        // Wire up previous controls.
        for (let i = 0; i < previousElements.length; i++) {
            const previousElement = previousElements[i];
            previousElement.addEventListener('click', this._onPrev.bind(this));
        }
    }

    _onNext(event) {
        event.preventDefault();

        if (this.activePage === this._length - 1) {
            this.activePage = 0;
        } else {
            this.activePage++;
        }
    }

    _onPrev(event) {
        event.preventDefault();

        if (this.activePage === 0) {
            this.activePage = this._length - 1;
        } else {
            this.activePage--;
        }
    }
}
